import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "./styles/automotive-theme.css";
import "./styles/typography.css";
import "./styles/global-premium.css";
import "./styles/offer-section.css";
import "./styles/advantage-section.css";
import "./styles/client-stories-section.css";
import "./styles/how-it-works-section.css";
import "./styles/footer-section.css";
import "./styles/premium-international.css";
import "./styles/pictures-theme.css";
import "./styles/pictures-status-screens.css";
import "./styles/damage-vehicle-guide.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "./Redux/store";
import ErrorBoundary from "./components/ErrorBoundary";

document.body.classList.add("pi-pictures-body");

ReactDOM.render(
  <Provider store={store}>
    <React.StrictMode>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </React.StrictMode>
  </Provider>,
  document.getElementById("root")
);

reportWebVitals();
